import { priceStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPrice";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import { TYPOGRAPHY } from "@store/theme/common/design";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
import { css } from "styled-components";

Object.assign(priceStyles, {
    productPrice: {
        price: {
            priceText: {
                color: "text.titles",
                weight: TYPOGRAPHY.weight.medium,
                css: css`
                    display: block;
                    font-size: 26px;
                    margin-bottom: 0 !important;

                    ${({ theme }) =>
                        breakpointValuesMediaQueries(
                            theme,
                            [{ values: ["26px", null, "30px", null, null], properties: ["font-size"] }],
                            mediaOptions.min,
                        )}
                `,
            },
        },
        msrpPrice: {
            size: 26,
            css: css`
                line-height: 1.2;

                ${({ theme }) =>
                    breakpointValuesMediaQueries(
                        theme,
                        [{ values: ["26px", null, "30px", null, null], properties: ["font-size"] }],
                        mediaOptions.min,
                    )}
            `,
        },
    },
});
